import { FC } from 'react'
import clsx from 'clsx'

import styles from './checkbox.module.scss'

interface IButton extends React.InputHTMLAttributes<HTMLInputElement> {
  modificator?: string
  spanModificator?: string
  labelModificator?: string
  children?: any
  field?: any
  noInnerHtml?: boolean
}

const Checkbox: FC<IButton> = ({
  children,
  modificator,
  spanModificator,
  labelModificator,
  noInnerHtml = false,
  ...props
}: IButton) => {
  return (
    <label className={clsx(styles.checkboxBox, { [labelModificator as string]: labelModificator })}>
      <input
        className={clsx(styles.checkbox, {
          [modificator as string]: modificator,
        })}
        type="checkbox"
        checked={!!props.value || false}
        {...props}
      />
      <span
        className={clsx(styles.checkmark, { [spanModificator as string]: spanModificator })}
      ></span>
      {noInnerHtml ? (
        <span> {children}</span>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: children }}></span>
      )}
    </label>
  )
}

export default Checkbox
